module.exports = __webpack_public_path__ + "static/primary-logo-14fffa0d28733a5252ccd5181d31a481.svg";